const bundle = state => state.bundle
const bundles = state => state.bundles
const loading = state => state.loading

export default {
  bundle,
  bundles,
  loading
}
